import { AssetType } from '@unistocks/proxy/axios-client';
import { mapEnumToOptions } from '@unistocks/shared/utils/enum-utils';

export const assetTypeOptions = mapEnumToOptions(AssetType, 'AssetType');
